import request from '@/utils/request'

// 配置
export function getConfig() {
    return request.get({ url: '/config/getConfig' })
}

// 工作台主页
export function getWorkbench() {
    return request.get({ url: '/workbench/index' })
}

//字典数据
export function getDictData(params: any) {
    return request.get(
        { url: '/config/dict', params },
        { ignoreCancelToken: true }
    )
}

// 获取地址列表
export function addressListCode(params: any) {
    return request.get({ url: '/Address/addressListCode', params })
}

// 获取地址信息
// export function getAddressList(params: any) {
//     return request.get({ url: '/Address/lists', params })
// }

//主页统计
export function apiCount() {
    return request.get({ url: '/index/count' })
}

// 上报文件列表/下载文件列表

export function apiFileXml(params: any) {
    return request.get({ url: '/FileXml/lists', params })
}
// 删除上报文件列表/下载文件列表
export function FileXmlDEl(params: any) {
    return request.post({ url: '/FileXml/delete', params })
}

// 更新文件列表
export function FileXmlUpdate(params: any) {
    return request.post({ url: '/FileXml/synchronousUploadFilePath', params })
}

//注册账号adminapi
export function apiRegister(params: any) {
    return request.post({ url: '/Login/register', params })
}

//注册账号adminapi
export function apiRetrieve(params: any) {
    return request.post({ url: '/Login/retrievePassword', params })
}
